// Scope ids contain ':', which i18next 17 reads as its namespace separator, and
// a falsy per-call nsSeparator is ignored. The lookup therefore passes a
// separator that never appears in these keys.
const SCOPE_KEY_OPTIONS = { nsSeparator: '|' };

// Label of a scope sent by the backend. A scope without a translation shows
// the backend's English description, else its raw id (always as plain text).
export function scopeLabel(t, { scope, description }) {
  const key = `mcp.scope.${scope}.label`;
  const label = t(key, SCOPE_KEY_OPTIONS);

  return label === key ? description || scope : label;
}

// The client name is chosen by the client. i18next interpolation rescans the
// replaced text, so a name such as "{{brand}}" would be expanded. The title is
// translated with a marker instead and split around it, and the caller renders
// the name as its own text node.
const CLIENT_MARKER = '@@client@@';

export function splitAroundClient(t, key, values) {
  return t(key, { ...values, client: CLIENT_MARKER }).split(CLIENT_MARKER);
}

// Same for a sentence with the client name and its domain (a DCR client
// declares its own domain). The outer list is split around the name, each
// inner list around the domain.
const DOMAIN_MARKER = '@@domain@@';

export function splitAroundClientAndDomain(t, key, values) {
  return splitAroundClient(t, key, { ...values, domain: DOMAIN_MARKER }).map((part) => part.split(DOMAIN_MARKER));
}
